import React from 'react';
import './About.css';
import aboutMain from "../../assets/about/abou.jpeg";
import aboutSmall from "../../assets/about/abou1.jpeg";

// ── Icons ─────────────────────────────────────────────────────
const ArrowRight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"/>
    <polyline points="12 5 19 12 12 19"/>
  </svg>
);

const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const AwardIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6"/>
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/>
  </svg>
);

const UsersIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 00-3-3.87"/>
    <path d="M16 3.13a4 4 0 010 7.75"/>
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

// ── Data ──────────────────────────────────────────────────────
const POINTS = [
  {
    icon: <TargetIcon />,
    title: 'Registered in 2021, Operations since July 2021',
    desc:  'Growing rapidly with 65+ completed projects across Singapore infrastructure.',
  },
  {
    icon: <ShieldIcon />,
    title: 'ISO 9001:2015 & ISO 45001:2018 Certified',
    desc:  'BizSafe Star rated — Safety First is embedded in every project we execute.',
  },
  {
    icon: <UsersIcon />,
    title: 'Experienced Leadership Team',
    desc:  'Directors with 22–23 years in Singapore construction & geotechnical fields.',
  },
  {
    icon: <AwardIcon />,
    title: '100% Project Completion Rate',
    desc:  'Every project delivered on time for LTA, PUB and private clients.',
  },
];

/*const PERSONNEL = [
  {
    initials: 'KN',
    name:     'K. Nedunchezian (Nedu)',
    role:     'Director & Operations Head',
    exp:      '22 Yrs Experience',
    desc:     'Switched to Geotechnical field in 2014. Proven track record in SI, Grouting, Recharge Wells & Pipe Jacking.',
  },
  {
    initials: 'MS',
    name:     'M. Subenthiran (Suben)',
    role:     'Share Holder & General Manager',
    exp:      '23 Yrs Experience',
    desc:     'Specialises in Designing & Execution of Ground Improvement works across Singapore.',
  },
  {
    initials: 'KG',
    name:     'Killiyappan Gopal',
    role:     'Major Share Holder',
    exp:      'Director — JAK Engg',
    desc:     'Also Director of JAK Engineering & Construction Pte Ltd and Jae Hwan Construction Pte Ltd.',
  },
];*/

// ── Component ─────────────────────────────────────────────────
const About = () => {
  return (
    <section className="gsk-about" id="about">

      {/* ── 2-column grid ── */}
      <div className="gsk-about__grid">

        {/* ═══ LEFT — Photo block ═══ */}
        <div className="gsk-about__photo-block">

          {/* Accent square behind */}
          <div className="gsk-about__img-accent" />

          {/* Main image */}
          <div className="gsk-about__img-main-wrap">
            <img
              src={aboutMain}
              alt="GSK Geotech site operations"
              className="gsk-about__img-main"
            />
            <div className="gsk-about__img-overlay" />
          </div>

          {/* Small inset image */}
          <div className="gsk-about__img-small-wrap">
            <img
              src={aboutSmall}
              alt="Drilling operations"
              className="gsk-about__img-small"
            />
          </div>

          {/* Experience badge */}
          <div className="gsk-about__exp-badge">
            <span className="gsk-about__exp-number">5<sup>+</sup></span>
            <span className="gsk-about__exp-label">Years of<br />Operation</span>
          </div>

        </div>

        {/* ═══ RIGHT — Content ═══ */}
        <div className="gsk-about__content">

          {/* Label */}
          <div className="gsk-about__label">
            <span className="gsk-about__label-line" />
            <span className="gsk-about__label-text">About Us</span>
          </div>

          {/* Heading */}
          <h2 className="gsk-about__heading">
            Your Trusted Partner<br />
            in <span>Geotechnical</span><br />
            Engineering
          </h2>

          {/* Body */}
          <p className="gsk-about__body">
            GSK Geotech Pte Ltd was registered in 2021 and commenced operations in July 2021.
            Based in Singapore, we specialise in Geotechnical Investigation, Ground Improvement,
            Grouting Works, Recharge & Relief Wells, Instrumentation & Monitoring & Pipe Jacking — serving LTA, PUB under leading private contractors
            across the island.
          </p>

          {/* Key points */}
          <div className="gsk-about__points">
            {POINTS.map((pt, i) => (
              <div className="gsk-about__point" key={i}>
                <div className="gsk-about__point-icon">{pt.icon}</div>
                <div className="gsk-about__point-text">
                  <span className="gsk-about__point-title">{pt.title}</span>
                  <span className="gsk-about__point-desc">{pt.desc}</span>
                </div>
              </div>
            ))}
          </div>

          

          {/* CTA */}
          <a href="contact-us" className="gsk-about__cta">
            Work With Us <ArrowRight />
          </a>

        </div>
      </div>

      

    </section>
  );
};

export default About;